import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api, { humanizeAxiosError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import SignatureCapture from "@/components/SignatureCapture";

/**
 * Personel bir bağlantıya veya bildirime tıkladığında bu sayfaya gelir.
 * Sayfa, kayıtlı imzasını (varsa) otomatik doldurur; personel imzayı
 * onaylayınca İK'nın önerdiği yeni şifre etkinleşir.
 */
export default function ApprovePasswordChange() {
  const { token } = useParams();
  const nav = useNavigate();
  const { user } = useAuth();
  const [sig, setSig] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (user?.signature) setSig(user.signature);
  }, [user]);

  const approve = async () => {
    if (!sig) { toast.error("Onaylamak için imzanız gerekli"); return; }
    setSubmitting(true);
    try {
      await api.post("/auth/hr-password-approve", { token, signature: sig });
      toast.success("Şifreniz güncellendi. Lütfen yeni şifreyle giriş yapın.");
      setTimeout(() => nav("/login"), 1200);
    } catch (e) {
      toast.error(humanizeAxiosError(e));
    } finally { setSubmitting(false); }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <Card className="w-full max-w-lg">
        <CardContent className="p-8 space-y-6">
          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Colossae Personel</div>
            <h1 className="font-display text-3xl font-bold mt-1">Şifre Değişikliği Onayı</h1>
            <div className="text-sm text-muted-foreground mt-2 leading-relaxed">
              İnsan Kaynakları, hesabınız için yeni bir şifre önerdi. Kayıtlı imzanızla
              onayladığınızda yeni şifre etkinleşecek. Bu talep sizin bilginiz dışında
              gelmişse "Vazgeç" tuşuna basın veya bu ekranı kapatın.
            </div>
          </div>

          <div>
            <div className="text-xs uppercase tracking-wider text-muted-foreground font-semibold mb-2">İmzanız</div>
            <SignatureCapture value={sig} onChange={setSig} />
            {user?.signature && (
              <div className="text-[11px] text-muted-foreground mt-1">
                Kayıtlı imzanız otomatik doldurulmuştur — dilerseniz üzerine yenisini çizebilirsiniz.
              </div>
            )}
          </div>

          <div className="flex gap-2">
            <Button variant="outline" onClick={() => nav("/")} data-testid="approve-cancel">Vazgeç</Button>
            <Button onClick={approve} className="flex-1" disabled={submitting || !sig} data-testid="approve-submit">
              {submitting ? "Kaydediliyor…" : "İmzamla Onayla ve Şifreyi Değiştir"}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
